import { render, staticRenderFns } from "./ProductItemView.vue?vue&type=template&id=113c6fc0&scoped=true&"
import script from "./ProductItemView.vue?vue&type=script&lang=js&"
export * from "./ProductItemView.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemView.vue?vue&type=style&index=0&id=113c6fc0&lang=scss&scoped=true&"
import style1 from "./ProductItemView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113c6fc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBreadcrumbs,VBtn,VCol,VContainer,VIcon,VRow,VSheet})
